import React, {useState} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useIntl, FormattedMessage  } from 'react-intl';
import DescriptionObject from './DescriptionObject';
import {Input, Button} from 'antd';
import { sendPost } from '../utils/utils';
import { fetchLicense } from '../actions/license';
import '../App.css'

const LicenseInfo = (props) => {  
    
    const [state, setState] = useState({
        changed: false,
        input_value: ""
    });

    const dispatch = useDispatch();
    let license = useSelector(state => state.license);
    if (Array.isArray(license) && license.length === 0)
    {
        dispatch(fetchLicense());
    }

    let intl = useIntl();   

    function getColumns()
    {
        var date_options = { year: 'numeric', month: 'long', day: 'numeric' };
        const lang = navigator.language || navigator.userLanguage;

        var columns = [
            {
                title :  <FormattedMessage id="SuppliesTable.status"/>,
                data : license.LicenseStatus,
            },
        ];

        if (license.IsEvaluation)
        {
            columns.push({
                    title :  <FormattedMessage id="TrialLicense"/>,
                    data : <FormattedMessage id="Yes"/>,
                },
            );
        }

        columns.push({
                title :  <FormattedMessage id="LicensedTo"/>,
                data : license.LicensedTo,
            },
        );

        let dateValidFrom = new Date(license.ValidFrom);
        columns.push({
                title :  <FormattedMessage id="ValidFrom"/>,
                data : dateValidFrom.toLocaleString(lang, date_options),
            },
        );

        if (license.ValidUntil)
        {
            let dateValidUntil = new Date(license.ValidUntil);
            columns.push({
                    title :  <FormattedMessage id="ValidUntil"/>,
                    data : dateValidUntil.toLocaleDateString(lang, date_options),
                },
            );
        }

        if (!license.IsEvaluation)
        {
            const tech_support_end_date = dateValidFrom;
            tech_support_end_date.setFullYear(tech_support_end_date.getFullYear() + 1);

            columns.push({
                    title :  <FormattedMessage id="TechnicalSupportUntil"/>,
                    data : tech_support_end_date.toLocaleString(lang, date_options),
                },
            );
        }

        if (license.MaxPrinters)
        {
            columns.push({
                    title :  <FormattedMessage id="MaxPrinters"/>,
                    data : license.MaxPrinters,
                },
            );
        }
        else
        {
            columns.push({
                    title :  <FormattedMessage id="MaxPrinters"/>,
                    data : <FormattedMessage id="Unlimited"/>,
                },
            );
        }

        return columns;
    }

    const onChange = (e) => {
        setState({changed: true, input_value: e.target.value});
      };

    function onSubmit() {
        sendPost('/license', {License: state.input_value}, intl);

        setTimeout(function(){ dispatch(fetchLicense()) }, 5000);

        setState({changed: false, input_value: ""});
    }

    return (
        <>
        <div className = "description-parent">
            <div className = "description-object"><DescriptionObject object = {getColumns()}/></div>            
        </div>
        <div className = "description-object">
            <span className="ant-form-text">{intl.formatMessage({ id: "EnterLicense" })}</span>
            <Input.TextArea className = "description-object" rows={6} onChange={onChange} value={state.input_value}/>            
            <Button style={{marginTop: 10}} type="primary" disabled={!state.changed} onClick = {onSubmit}>{intl.formatMessage({ id: "Submit" })}</Button>
        </div>
        </>
    );   
}
  
export default LicenseInfo;